import type { ResourceType } from "@gettactic/api";
import { shouldEnablePrivacyForResourceType } from "@gettactic/helpers/src/resources/utils";
import { useSettings } from "@gettactic/hooks";

/**
 * Whether office privacy hides who owns or occupies a resource of this type.
 * Every card that names owners reads it from here, so none of them becomes
 * the way around it.
 */
export const useHidesResourceIdentity = (
  officeId: string | null | undefined,
  type: ResourceType | null | undefined
): boolean => {
  const { isOfficePrivacyEnabled } = useSettings();
  return (
    !!officeId &&
    !!type &&
    isOfficePrivacyEnabled(officeId) &&
    shouldEnablePrivacyForResourceType(type)
  );
};
